import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

export const getDataItemCostBearer = (state: State) => state.dataItemCostBearer;
export const getIsLoadingCostBearer = (state: State) => state.isLoadingCostBearer;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getDataItemCostBearer,
  getIsLoadingCostBearer,
};
